
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {defineComponent} from "vue";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IoablePageMixin from "@/router/IoablePageMixin";
import PathInfoMixin from "@/router/PathInfoMixin";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import Formatter from "@/utils/Formatter";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Swal from "sweetalert2";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import FormatGroupTable from "@/components/pages/contract/TradeContractFormatGroup/FormatGroupTable.vue";

export default defineComponent({
  name: 'FormatGroupTab',
  components: {
    FormatGroupTable,
    SimpleDialog,
    IconBtns,
    TableInline, TextFieldLike,
    IconBtn,
    TabItemTemplate
  },
  inject: ['tabItemBounds'],
  mixins: [
    IoablePageMixin,
    PathInfoMixin,
    TableUtil,
    Formatter,
  ],
  data() {
    return {
      tradeContractFormatGroups: [] as TradeContractFormatGroup[],
      createDialog: {
        visible: false,
        form: {
          name: '',
          description: '',
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    readonly(): boolean {
      return !this.isEditable;
    },
    tradeContractFormatGroupsView(): TradeContractFormatGroup[] {
      return this.tradeContractFormatGroups;
    }
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormatGroups: "hcs/tradeContractFormatGroup/findList",
      deleteTradeContractFormatGroups: "hcs/tradeContractFormatGroup/delete",
      createTradeContractFormatGroups: "hcs/tradeContractFormatGroup/create",
    }),
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    async load() {
      this.tradeContractFormatGroups = await this.fetchTradeContractFormatGroups();
    },
    async handleDeleteButtonClick(row: TradeContractFormatGroup) {
      const {value: confirm} = await Swal.fire({
        title: '確認',
        icon: 'info',
        html: `本当に取引契約フォーマットグループ <strong>${row.name}</strong> を削除してよろしいですか。`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ"
      });
      if(!confirm) {
        return;
      }

      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
      });
      try {
        await this.deleteTradeContractFormatGroups(row.id);

        this.showSnackbar({
          message: `取引契約フォーマットグループ ${row.name} を削除しました`,
        });
      } catch (e) {
        console.error(e);
        this.showSnackbar({
          color: 'failed',
          message: `取引契約フォーマットグループ ${row.name} の削除に失敗しました`,
        });
      } finally {
        loading.close();
      }
    },
    handleCreateButtonClick() {
      this.createDialog = {
        visible: true,
        form: {
          name: '',
          description: '',
        }
      }
    },
    async handleCreateDialogClose(apply: boolean) {
      if(apply) {
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
        });
        try {
          const form = this.createDialog.form;
          await this.createTradeContractFormatGroups(form);

          this.showSnackbar({
            message: `取引契約フォーマットグループ ${form.name} を作成しました`,
          });
        } catch (e) {
          console.error(e);
          this.showSnackbar({
            color: 'failed',
            message: `取引契約フォーマットグループの作成に失敗しました`,
          });
        } finally {
          loading.close();
        }
      }

      this.createDialog.visible = false;
    }
  },

});
